<template>
  <div>
    <tokens-demand-list
      :value="demandList"
      :loading="loadingData"
      :search="search"
      :cancellable="item => item.status === 'inProgress'"
      @cancel="cancelDemand"
    />

    <!-- RouterView for modals -->
    <router-view />
  </div>
</template>

<script>
import Repositories from 'src/repositories'

import { mapActions } from 'vuex'
import TokensDemandList from '../components/TokensDemandList'

export default {
  name: 'TokensDemandContainer',
  components: {
    TokensDemandList,
  },
  props: {
    search: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    demandList: [],
    loadingData: false,
  }),
  watch: {
    $route: {
      immediate: true,
      handler ({ name }) {
        if (name === 'TokensDemand') {
          this.fetchData()
        }
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    async fetchData () {
      this.loadingData = true
      this.demandList = await Repositories.myCompany.getTokensDemandList()
      this.loadingData = false
    },
    async cancelDemand (demandId) {
      try {
        await Repositories.myCompany.patchTokensDemand({
          id: demandId,
          status: 'cancel',
        })
        this.demandList = await Repositories.myCompany.getTokensDemandList()
        this.showSuccessNotification(this.$t('tokens.demands.cancelSuccess'))
      }
      catch (error) {
        this.showErrorNotification(this.$t('tokens.demands.cancelError'))
      }
    },
  },
}
</script>
